import * as actionTypes from '../actionTypes/shareItems';

export default {
  setShareItemsResStatus: (status: string) => ({
    type: actionTypes.SET_SHARE_ITEMS_RES_STATUS,
    payload: {
      status,
    },
  }),
  setDocApprovalStatus: (status: string) => ({
    type: actionTypes.SET_DOC_APPROVAL_STATUS,
    payload: {
      status,
    },
  }),
};
